'use client';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { tw } from '@repo/ui';
import { getImageUrl } from '@repo/utils';

import { ClaimButton } from '../button';

interface ErrorProps {
  isClaimActive: boolean;
}

export const Error: React.FC<ErrorProps> = ({ isClaimActive }) => {
  const router = useRouter();

  return (
    <div
      className={tw(
        'relative z-10 mx-auto flex w-full max-w-6xl flex-col',
        'bg-black px-2 md:px-0',
      )}
    >
      <div
        className={tw(
          'mb-16 mt-24 flex w-full flex-col items-center md:mb-4 md:mt-12',
        )}
      >
        <div className='relative h-auto w-full'>
          <Image
            src={getImageUrl('/claim/images/main-dood.gif')}
            alt='Dood'
            layout='responsive'
            width={500}
            height={339}
            quality={100}
          />
        </div>
      </div>

      <div
        className={tw(
          'z-20 flex flex-col items-center justify-end gap-4 px-4 pb-4 text-white',
        )}
      >
        <p className='text-center text-sm font-semibold uppercase md:text-base'>
          {isClaimActive ? 'Claim' : 'Pre-registration'} Currently Unavailable
        </p>
        <p className='text-center text-sm font-thin opacity-50 md:text-base'>
          We're experiencing a temporary issue. Please try refreshing the page,
          or check back in a few minutes. We appreciate your patience!
        </p>

        <div className='mx-auto w-[300px]'>
          <ClaimButton
            onClick={() => router.refresh()}
            text='TRY AGAIN'
            hasEnoughSol
            hasSolWallet
          />
        </div>
      </div>
    </div>
  );
};
